import React, { useState } from 'react'
import { useInterval } from '../hooks'

export const Loader = () => {
  const [dots, setDots] = useState('')

  useInterval(() => {
    if (dots.length === 3) {
      setDots('')
    } else {
      setDots(dots + '.')
    }
  }, 400)

  return <div>Loading{dots}</div>
}
